/** Path routing for the console.
 *
 * The console is something you link a colleague to, bookmark, and reload, so it
 * gets real URLs (`/admin/users/<id>`) rather than a hash or component state.
 *
 * Deliberately this short instead of a router dependency: eight routes and one
 * optional id. History handling itself lives in `pathname.ts`, shared with the
 * email landing paths.
 */

export const ADMIN_PREFIX = '/admin'

export const ADMIN_SECTIONS = [
  'overview',
  'users',
  'reminders',
  'households',
  'stores',
  'triggers',
  'system',
  'audit',
] as const

export type AdminSection = (typeof ADMIN_SECTIONS)[number]

export interface AdminRoute {
  section: AdminSection
  /** The selected row, for sections that have a detail panel. */
  id?: string
}

/** Null when the path is not the console at all. */
export function parseAdminPath(pathname: string): AdminRoute | null {
  if (pathname !== ADMIN_PREFIX && !pathname.startsWith(`${ADMIN_PREFIX}/`)) return null
  const [section, id] = pathname.slice(ADMIN_PREFIX.length).replace(/^\/|\/$/g, '').split('/')
  if (!section) return { section: 'overview' }
  if (!(ADMIN_SECTIONS as readonly string[]).includes(section)) return { section: 'overview' }
  return id ? { section: section as AdminSection, id } : { section: section as AdminSection }
}

export function adminHref(section: AdminSection, id?: string): string {
  return `${ADMIN_PREFIX}/${section}${id ? `/${id}` : ''}`
}
